import { cn } from '../../lib/cn';

export const avatars = [
  ['query-architect', 'معمار جواب', 'QA'], ['index-scout', 'ردیاب ایندکس', 'IX'],
  ['join-smith', 'استاد اتصال', 'JN'], ['window-navigator', 'ناوبر پنجره', 'WN'],
  ['data-sentinel', 'نگهبان داده', 'DS'], ['cte-pilot', 'خلبان CTE', 'CT'],
  ['null-hunter', 'شکارچی NULL', 'Ø'], ['schema-cartographer', 'نقشه‌کش شِما', 'SC'],
  ['aggregate-forger', 'سازنده تجمیع', 'Σ'], ['execution-analyst', 'تحلیلگر پاسخ', 'EX'],
  ['transaction-keeper', 'پاسبان تراکنش', 'TX'], ['rank-strategist', 'استراتژیست رتبه', '#1'],
] as const;

export const teamColors = ['#F26A21', '#7C3AED', '#2563EB', '#0891B2', '#0F766E', '#65A30D', '#CA8A04', '#DB2777', '#DC2626', '#4F46E5'] as const;

export function TeamAvatar({ avatarId, color, className }: { avatarId: string; color: string; className?: string }) {
  const avatar = avatars.find(([id]) => id === avatarId) ?? avatars[0];
  return (
    <div
      className={cn('relative grid size-12 shrink-0 place-items-center overflow-hidden rounded-[16px] text-sm font-black text-white shadow-lg', className)}
      style={{ background: `linear-gradient(145deg, ${color}, ${color}bb)` }}
      title={avatar[1]}
    >
      <span className="absolute inset-x-2 top-2 h-px bg-white/35" />
      <span className="absolute inset-x-2 bottom-2 h-px bg-black/15" />
      <span className="relative tracking-tight" dir="ltr">{avatar[2]}</span>
    </div>
  );
}
